import React from "react";
import DashboardShellBase from "../../pages/SHARED/components/DashboardShellBase";

const InternalUserDashboard = (props) => (
  <DashboardShellBase {...props} variant="internal" />
);

export default InternalUserDashboard;
